export function getElementTag(name: string, entry: string, version: string): string {
  const formattedVersion = version ? `v${version.split('.')[0]}` : ''
  return `${name}-${entry}-${formattedVersion}`
}
